var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyGoTribeNew = function SvgHappyGoTribeNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 49 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#414042",
    fillRule: "evenodd",
    d: "M6.5 12.769q1.192-1.09 1.192-3.05l.003-6.266H5.412v.823h-.029q-.68-.995-2.022-.995-1.512 0-2.436 1.055Q0 5.392 0 7.19q-.003 1.602.828 2.556t2.246.954q1.526 0 2.306-1.19h.029v.56q0 1.002-.636 1.586-.633.585-1.79.584a4.7 4.7 0 0 1-2.309-.635v1.838q.879.407 2.37.407 2.262.01 3.455-1.081M5.436 6.565v.56h.001c.025.497-.13.987-.437 1.377-.28.344-.703.536-1.144.522a1.37 1.37 0 0 1-1.128-.514q-.413-.515-.413-1.4c0-.69.146-1.218.434-1.595a1.42 1.42 0 0 1 1.193-.568c.412-.013.808.16 1.079.473.277.315.425.724.415 1.145M9.621 9.708q1.06.992 2.909.992 1.874 0 2.955-1.023 1.08-1.024 1.081-2.785.003-1.632-1.044-2.622t-2.89-.99q-1.873-.001-2.97.99-1.098.992-1.098 2.747-.003 1.7 1.057 2.691m1.71-4.226c.316-.362.78-.559 1.258-.532h.001q1.654 0 1.654 1.984 0 2.093-1.64 2.093-1.72 0-1.72-2.037 0-.975.447-1.508",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#414042",
    d: "M25.297 7.124v-.56c-.01-.42.138-.83.415-1.144a1.37 1.37 0 0 1 1.078-.473q.199 0 .39.044l.607-.94c.1-.151.11-.346.026-.507a.49.49 0 0 0-.428-.268h-.009q-1.343 0-2.022.995h-.029a.83.83 0 0 0-.238-.582.8.8 0 0 0-.576-.24h-.656a.8.8 0 0 0-.576.24.83.83 0 0 0-.237.582v5.603c0 .454.363.822.813.823h.628c.45 0 .814-.368.814-.823z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.255,
    height: 7.321,
    x: 28.709,
    y: 3.379,
    fill: "#414042",
    rx: 1.128
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#414042",
    fillRule: "evenodd",
    d: "M36.422 3.473q1.416 0 2.248.954.83.953.83 2.558 0 1.798-.924 2.853-.925 1.056-2.436 1.055-1.351 0-2.023-.995h-.028a.83.83 0 0 1-.239.582.8.8 0 0 1-.575.24h-.657a.817.817 0 0 1-.813-.822V1.01c0-.453.364-.821.813-.821h.655a.8.8 0 0 1 .578.24.83.83 0 0 1 .238.584v3.648h.028q.782-1.188 2.305-1.188m-.868 5.742c.465.02.91-.192 1.193-.567v.006c.29-.378.434-.909.434-1.602q0-.885-.411-1.4a1.37 1.37 0 0 0-1.128-.514 1.42 1.42 0 0 0-1.146.524c-.286.345-.435.806-.435 1.376V7.6c-.01.42.138.829.414 1.143.272.313.667.487 1.079.473M48.133 6.889v.096l-.003.234a.35.35 0 0 1-.1.247.34.34 0 0 1-.245.103h-5.297q.224 1.454 1.675 1.455a1.53 1.53 0 0 0 1.1-.382.34.34 0 0 1 .365-.072l1.311.532a.348.348 0 0 1 .115.567q-1.078 1.023-2.958 1.022-1.85.003-2.908-.99-1.059-.994-1.058-2.692v-.028q-.002-1.722 1.098-2.714t2.97-.992q1.846 0 2.89.992t1.045 2.622m-2.378-.585q-.238-1.357-1.602-1.357c-.48-.027-.944.17-1.26.535a1.85 1.85 0 0 0-.381.822z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#happyGoTribeNew_svg__a)",
    d: "M19.755.285 16.632.51a.847.847 0 0 0-.782.847v.64c0 .236.097.46.266.62.17.16.397.243.629.228l1.426-.102A5 5 0 0 1 19.755.285"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#happyGoTribeNew_svg__b)",
    d: "M24.612 1.496V.849a.86.86 0 0 0-.266-.62.84.84 0 0 0-.629-.227L19.77.285a5 5 0 0 0-1.592 2.467l5.646-.406c.444-.028.79-.4.79-.85"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#happyGoTribeNew_svg__c)",
    d: "M24.612 1.496V.849a.86.86 0 0 0-.266-.62.84.84 0 0 0-.629-.227L19.77.285a5 5 0 0 0-1.592 2.467l5.646-.406c.444-.028.79-.4.79-.85"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#happyGoTribeNew_svg__d)",
    d: "M20.937 4.109c0-.925.741-1.674 1.656-1.674l1.232-.09a.845.845 0 0 0 .787-.85V.854a.85.85 0 0 0-.269-.623.83.83 0 0 0-.635-.224L22.6.091a3.95 3.95 0 0 0-2.815 1.174 4.04 4.04 0 0 0-1.166 2.844v5.703c0 .469.376.849.84.849h.638c.464 0 .84-.38.84-.849z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#happyGoTribeNew_svg__e)",
    d: "m23.701.006-1.108.085h-.182l-.222.015a3.98 3.98 0 0 0-3.318 2.588l3.522-.244c.054 0 .107-.01.161-.012l1.27-.09a.847.847 0 0 0 .789-.852V.854a.85.85 0 0 0-.271-.627.83.83 0 0 0-.64-.22"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.836,
    cy: 1.609,
    fill: "#414042",
    rx: 1.401,
    ry: 1.416
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "happyGoTribeNew_svg__a",
    x1: 16.838,
    x2: 15.514,
    y1: -1.031,
    y2: 2.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E63148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "happyGoTribeNew_svg__b",
    x1: 20.955,
    x2: 18.748,
    y1: 0.308,
    y2: 3.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF125D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3478"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "happyGoTribeNew_svg__c",
    x1: 20.67,
    x2: 21.217,
    y1: 4.383,
    y2: 2.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E63148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "happyGoTribeNew_svg__d",
    x1: 20.311,
    x2: 26.688,
    y1: 14.611,
    y2: 9.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FA961A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#FFB305"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "happyGoTribeNew_svg__e",
    x1: 27.048,
    x2: 27.85,
    y1: 12.289,
    y2: 3.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D38"
  })))));
};
export default SvgHappyGoTribeNew;